import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=c6ff2f40&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"
import style0 from "./refund.vue?vue&type=style&index=0&id=c6ff2f40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff2f40",
  null
  
)

export default component.exports